exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// /var/www/vhosts/super-x.blog/httpdocs/~/core-js/modules/_object-gops.js
// module id = 72
// module chunks = 0